export default class Blocks {
    constructor() {
        this.selector = '[data-blocks]';
        this.init();
    }

    init() {
        var self = this,
            $blocks = $( self.selector );

        $blocks.hover( function() {
            var $this = $( this );
            $this.addClass( 'hovered' );
        }, function() {
            var $this = $( this );
            $this.removeClass( 'hovered' );
        } );
    }
}